import styled from 'styled-components';

interface ButtonProps {
  isBlocked: boolean;
}

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;

  table .lflqij {
    display: none;
  }

  table {
    .cellModify {
      position: sticky;
      left: 0;
      top: 0;
      min-width: 100px;
      background-color: #57069e;
      z-index: 3;
      text-align: center;
    }
  }

  .disabled-linear-progress {
    div {
      background: transparent !important;
    }
  }

  .editable {
    background: #dcf2bb;
    /* input {
      margin-top: -20px;
    } */
  }
`;

export const ContainerLoader = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonRow = styled.button<ButtonProps>`
  border: none;
  background-color: transparent;
  color: #3d3d3d;
  cursor: ${({ isBlocked }) => (isBlocked ? 'not-allowed' : '')};
  &:nth-child(2) {
    margin-left: 10px;
  }
  &:hover {
    background-color: #f4f5f7 !important;
    color: #000;
    transition: 0.4s;
    text-decoration: underline;
  }
`;
